"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateScriptModal = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Spinner_1 = __importDefault(require("react-bootstrap/Spinner"));
const updateScript_1 = require("@/utils/updateScript");
const firestore_1 = require("comodel/firestore");
const standard_1 = require("react-hook-schema/standard");
const pages_1 = require("../../../../../../../pages");
const CreateScriptModal = ({ show, onHide, projectId, segmentId, }) => {
    const [newScriptText, setNewScriptText] = (0, react_1.useState)("");
    const [isCreating, setIsCreating] = (0, react_1.useState)(false);
    const alert = (0, standard_1.useAlert)();
    const errorModal = (0, standard_1.useErrorModal)();
    const navigate = (0, pages_1.useTypedNavigate)();
    const handleCreateScript = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!newScriptText.trim()) {
            alert({ message: "テキストを入力してください" });
            return;
        }
        setIsCreating(true);
        try {
            const newScriptId = (0, firestore_1.getUniqueId)();
            const now = Date.now();
            const newScriptData = {
                segmentScriptId: `${segmentId}:${newScriptId}`,
                scriptId: newScriptId,
                projectId,
                segmentId,
                createdAt: now,
                text: newScriptText.trim(),
                translations: {},
                translationStatus: {},
                translationIgnore: {},
                tags: [],
            };
            yield (0, updateScript_1.updateScript)({
                projectId,
                segmentId,
                scriptId: newScriptId,
                data: newScriptData,
            });
            // Navigate to the newly created script
            const encodedScriptId = encodeURIComponent(newScriptId);
            navigate("UPDATE_SEGMENT_SCRIPT", {
                projectId,
                scriptId: encodedScriptId,
                segmentId,
            }, { retainSearchParams: true });
            // Reset modal state
            setNewScriptText("");
            onHide();
        }
        catch (error) {
            errorModal({
                error: error,
                internalMessage: "Error creating script",
                userMessage: "新しいテキストの作成に失敗しました。この問題が繰り返す場合は管理者にお問い合わせください。",
            });
        }
        finally {
            setIsCreating(false);
        }
    }), [
        newScriptText,
        projectId,
        segmentId,
        navigate,
        alert,
        errorModal,
        onHide,
    ]);
    const handleHide = (0, react_1.useCallback)(() => {
        if (!isCreating) {
            setNewScriptText("");
            onHide();
        }
    }, [isCreating, onHide]);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: handleHide },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u65B0\u3057\u3044\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "\u65E5\u672C\u8A9E\u30C6\u30AD\u30B9\u30C8"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 4, placeholder: "\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", value: newScriptText, onChange: (e) => setNewScriptText(e.target.value), disabled: isCreating }))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: handleHide, disabled: isCreating }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleCreateScript, disabled: isCreating || !newScriptText.trim() }, isCreating ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Spinner_1.default, { as: "span", animation: "border", size: "sm", role: "status", "aria-hidden": "true", className: "me-2" }),
                "\u4F5C\u6210\u4E2D")) : ("作成")))));
};
exports.CreateScriptModal = CreateScriptModal;
